import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CopyEmailIcon = (props: IconProps) => (
  <Icon width="18px" height="18px" viewBox="0 0 18 18" {...props}>
    <path d="M3 14.25H15V15.75H3C2.175 15.75 1.5 15.075 1.5 14.25V6H3V14.25ZM15.75 2.625C16.575 2.625 17.25 3.3 17.25 4.125V10.875C17.25 11.7 16.575 12.375 15.75 12.375H6C5.175 12.375 4.5 11.7 4.5 10.875V4.125C4.5 3.3 5.175 2.625 6 2.625H15.75ZM10.875 8.12256L6 5.625V10.875H15.75V5.625L10.875 8.12256ZM6 4.125L10.875 6.62256L15.75 4.125H6Z" />
  </Icon>
);

export default memo(CopyEmailIcon);
